import * as React from "react"; // Usa l'importazione namespace
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
// import { Search } from "lucide-react"; // Rimosso perché usiamo <select> standard

import Select from "react-select";
import { SaveIcon, Search } from "lucide-react";
import config from "./config";
import { getProfileFromToken } from "./config";
import MHeader from "./header";
import Mfooter from "./footer";


function AddInfo({ user }) {

  const navigate = useNavigate();

  // --- Guardia per la rotta Admin ---
  React.useEffect(() => {
    let profile = getProfileFromToken();
    if (profile !== "Admin") {
      navigate("/");
    }
  }, [navigate]);

  // --- Stato per i campi del nuovo  Info ---
  const [tipo, setTipo] = React.useState('');
  const [descrizione, setDescrizione] = React.useState('');
  const [contenuto, setContenuto] = React.useState('');
  const [dataAggiornamento, setDataAggiornamento] = React.useState('');

  // --- Stato per la Dropdown dei BIMObj ---
  const [bimObjList, setBimObjList] = React.useState([]); // Array di oggetti
  const [selectedBimObj, setSelectedBimObj] = React.useState(''); // L'ID scelto
  const [isLoading, setIsLoading] = React.useState(true);

  // --- Carica i BIMObj per la dropdown all'avvio ---
 /* React.useEffect(() => {
    const fetchBimObjs = async () => {
      setIsLoading(true);
      try {
        // Assumo un endpoint API '/bimobjs'
        const response = await fetch(config.apiUrl + 'bimobjs', { 
          headers: { "Authorization": "Bearer " + localStorage.getItem("token") }
        });
        if (response.ok) {
          const data = await response.json();
          if (Array.isArray(data)) {
            setBimObjList(data); // Salva l'array
          }
        } else {
          alert('Impossibile caricare elenco Oggetti BIM.');
        }
      } catch (error) {
        console.error('Errore caricamento Oggetti BIM:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchBimObjs();
  }, []); // Esegui solo al montaggio
*/
    useEffect(() => {
    
     fetch(config.apiUrl+"/bimobj")
      .then((res) => res.json())
      .then((data) => setBimObjList(data))
      .catch((error) => console.error("Errore nel fetch dei bimobj:", error))
  }, []); // L'array vuoto [] significa "esegui solo al montaggio"

  // --- Gestione Invio Form ---
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!selectedBimObj) {
      alert("Per favore, seleziona un Oggetto.");
      return;
    }

    const formData = new FormData();
    formData.append('idbimobj', selectedBimObj.value); // Associa all'ID del bimobj
    formData.append('tipo', tipo);
    formData.append('descrizione', descrizione);
    formData.append('contenuto', contenuto);
    formData.append('dataaggiornamento', dataAggiornamento);

    try {
      // Assumo un endpoint API '/newbiminfo'
      const response = await fetch(config.apiUrl + '/newbiminfo', {
        method: 'POST',
        headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        },
        body: formData,
      });

      if (response.ok) {
        alert(`Informazione aggiuntea con successo!`);
        navigate("/"); // Ritorna alla home
      } else {
        alert('Errore durante il salvataggio Informazione');
      }
    } catch (error) {
      console.error('Errore:', error);
      alert('Si è verificato un errore durante il salvataggio.');
    }
  };

  // Stili (come negli esempi precedenti)

  return (
    <div className="App"> 
        <h2  className="App-header">{config.appName}</h2>
      <MHeader />
      <p><small>utente: {user}</small></p>
      
      <h2>Aggiungi Info a Oggetto </h2>
      
      <form onSubmit={handleSubmit} >
          <label >Associa a Oggetto:</label><p></p>
            <Select
            options={bimObjList}
            value={selectedBimObj}
            onChange={setSelectedBimObj}
            placeholder="Seleziona un oggetto..."
            isClearable
          />
        <Search  size={1} />
        
        {/* Selezione Oggetto BIM */}
         <div style={{ border: '1px solid #ccc', padding: '1rem', margin: '1rem 0', borderRadius: '8px' }}>


        

        {/* Tipo */}
        
          <p></p><label >Tipo:</label><p></p>
          <input
            
            type="text"
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
          />
        

        {/* Descrizione */}
        
          <p></p><label>Descrizione:</label><p></p>
          <textarea
            
            value={descrizione}
            onChange={(e) => setDescrizione(e.target.value)}
          />
        

        {/* Contenuto */}
        
          <p></p><label>Contenuto:</label><p></p>
          <textarea
            
            value={contenuto}
            onChange={(e) => setContenuto(e.target.value)}
          />


        {/* Data Aggiornamento */}
         <p></p> <label>Data Aggiornamento:</label><p></p>
          <input
            type="date"
            value={dataAggiornamento}
            onChange={(e) => setDataAggiornamento(e.target.value)}
          />
        <p></p><button type="submit" ><SaveIcon className="mr-2" /><br/>Salva Informaziones</button>
        </div>
        
      </form>
      
      <Mfooter/>
    </div>
  );
}

export default AddInfo;

